import WarningTriangle from 'components/Icons/WarningTriangle';
import { Button } from 'components/lib';
import moment from 'moment';
import React, { ReactElement } from 'react';
import { RFIForwardActivity } from 'records/RFIForwardActivity';
import { User } from 'records/User';
import { useTranslator } from '@bluebeam/react-i18n';

export const ForwardInstructions: React.FC<{ children: ReactElement }> = ({
  children,
}) => {
  const { translate } = useTranslator(['rfiPage']);
  return (
    <div className="column justify-start items-center pt8 px3 black-2 font-size-5">
      <span className="font-size-7">{translate('rfiPage:forwardHeader')}</span>
      <div
        className="center pt3"
        style={{ paddingBottom: '32px', width: '20rem' }}
      >
        {translate('rfiPage:forwardDescription')}
      </div>
      {children}
    </div>
  );
};

export const CreateOfficialResponseButton: React.FC<{
  onClick: () => void;
}> = ({ onClick }) => {
  const { translate } = useTranslator(['buttons']);

  return (
    <div className="pos-r">
      <div
        className="pos-a"
        style={{ top: '-54px', left: '50%', marginLeft: '-25%' }}
      >
        <Button
          data-testid="view-rfi-create-response-btn"
          variant="primary"
          size="large"
          onClick={onClick}
        >
          {translate('buttons:rfiResponse')}
        </Button>
      </div>
    </div>
  );
};

export const ForwardNotificationBanner: React.FC<{
  forwardActivity: RFIForwardActivity;
  forwardedBy: User;
  onClick: () => void;
}> = ({ forwardActivity, onClick, forwardedBy }) => {
  const { translate } = useTranslator(['rfiPage', 'buttons']);
  return (
    <div className="pos-r">
      <div
        className="pos-a hrem-5 row items-center justify-between bgd-white w100 bt-3 px3"
        style={{ top: '-80px', left: '0px' }}
      >
        <div className="black-1 font-size-4">
          <span className="block medium">{`${forwardedBy?.profile.firstname} ${forwardedBy?.profile.lastname}`}</span>
          <span className="block">
            {translate('rfiPage:forwardedToYou')}{' '}
            {moment(forwardActivity.timestamp * 1000).format('ll')}
          </span>
        </div>
        <button className="btn btn-primary" onClick={onClick}>
          {translate('buttons:respond')}
        </button>
      </div>
    </div>
  );
};

export const AttachDiscussionToResponse: React.FC<{
  onClick: () => void;
  disabled: boolean;
}> = ({ onClick, disabled = false }) => {
  const { translate } = useTranslator(['buttons']);

  return (
    <div className="pos-r">
      <div
        id="view-rfi-overlay-attach-discussion-button"
        className="pos-a"
        style={{ top: '-54px', left: '50%', marginLeft: '-25%' }}
      >
        <Button
          variant="primary"
          size="large"
          onClick={onClick}
          disabled={disabled}
        >
          {translate('buttons:rfiAttachDiscussion')}
        </Button>
      </div>
    </div>
  );
};

export const LatestVersionBanner: React.FC<{
  showLatestVersion: () => void;
}> = ({ showLatestVersion }) => {
  const { translate } = useTranslator(['rfiPage']);

  return (
    <div
      className="row justify-center align-center bgd-light-grey-2 bb-3 font-size-2"
      style={{ paddingTop: '12px', paddingBottom: '10px', zIndex: 3 }}
    >
      <div className="status-orange" style={{ marginRight: '6px' }}>
        <WarningTriangle width="18px" height="16px" />
      </div>
      <div style={{ lineHeight: '16px' }}>
        {translate('rfiPage:viewingEarlyVersion')}{' '}
        <button
          onClick={showLatestVersion}
          className="btn-outline-primary bgd-light-grey-2 font-size-2 bold"
          style={{
            border: 0,
            paddingTop: 0,
            paddingBottom: 0,
            cursor: 'pointer',
          }}
        >
          {translate('rfiPage:latestVersion')}
        </button>
      </div>
    </div>
  );
};

export const LatestDraftBanner: React.FC<{
  showLatestVersion: () => void;
}> = ({ showLatestVersion }) => {
  const { translate } = useTranslator(['rfiPage']);

  return (
    <div
      className="row justify-center align-center bgd-light-grey-2 bb-3 font-size-2"
      style={{ paddingTop: '12px', paddingBottom: '10px', zIndex: 3 }}
    >
      <div className="status-orange" style={{ marginRight: '6px' }}>
        <WarningTriangle width="18px" height="16px" />
      </div>
      <div style={{ lineHeight: '16px' }}>
        {translate('rfiPage:reopenedRFI')}
        <button
          onClick={showLatestVersion}
          className="btn-outline-primary bgd-light-grey-2 font-size-2 bold"
          style={{
            border: 0,
            paddingTop: 0,
            paddingBottom: 0,
            cursor: 'pointer',
          }}
        >
          {translate('rfiPage:latestDraft')}
        </button>
      </div>
    </div>
  );
};
